import { render, staticRenderFns } from "./leftMain.vue?vue&type=template&id=f4cf057c&scoped=true"
import script from "./leftMain.vue?vue&type=script&lang=js"
export * from "./leftMain.vue?vue&type=script&lang=js"
import style0 from "./leftMain.vue?vue&type=style&index=0&id=f4cf057c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4cf057c",
  null
  
)

export default component.exports